/** コンテンツタイプ コミック. */
export const CONTENTS_TYPE_COMIC = "comic";
/** コンテンツタイプ アメコミ. */
export const CONTENTS_TYPE_AMECOMI = "amecomi";
/** コンテンツタイプ 小説. */
export const CONTENTS_TYPE_NOVEL = "novel";